import { SET_CUT_NODE } from 'redux/constants/flowDesigner';
import {
	SET_FLOW_BY_ID,
	FETCH_FLOW_BY_ID,
	DUPLICATE_FLOW,
	UPDATE_CURRENT_FLOW,
	AUTO_CREATE_NEW_FLOW,
	AUTO_UPDATE_CURRENT_FLOW,
	SET_SAVED_FLOW,
	SET_SAVING_FLOW_FLAG_RESET,
	SET_AUTO_SAVING_FLOW_FLAG_RESET,
	CLEAR_CURRENT_SAVED_FLOW,
	SET_SAVING_FLOW_PROPERTIES_FLAG_RESET,
	CREATE_NEW_FLOW_PROPERTIES,
	UPDATE_CURRENT_FLOW_PROPERTIES,
	SET_FLOW,
	UPDATE_FLOW_STEPS,
	SET_CANVAS_FLOW_INSTANCE,
	RELOAD_FLOW,
	UPDATE_FLOW_THUMBNAIL,
	AUTO_SAVE_ON_CANCEL_RESET,
	START_DRAG_COMPONENT,
	STOP_DRAG_COMPONENT,
	CLEAR_FLOW,
	OPEN_FLOW_LIST_DIALOG,
	CLOSE_FLOW_LIST_DIALOG,
	SET_NEW_TAB_FLAG,
	OPEN_RECENT_ACTIVITIES_DIALOG,
	CLOSE_RECENT_ACTIVITIES_DIALOG,
	SHARE_DESIGNER_FLOW,
	UNSHARE_FLOW,
	SET_SHARE_FLOW_FLAG_RESET,
	UPDATE_SHARE_FLOW,
	ADD_FLOW_VARIABLE,
	DELETE_FLOW_VARIABLE,
	UPDATE_FLOW_VARIABLE,
	SET_FLOW_VARIABLES,
	OPEN_DUPLICATE_FLOW_DIALOG,
	CLOSE_DUPLICATE_FLOW_DIALOG,
	SET_NUMBER_OF_NODES_LIMIT_REACHED,
	SET_COPIED_NODE,
	SET_IS_NOTES_DIALOG_OPEN,
	SET_NODE_TO_ADD_NOTES,
	SET_DRAGGED_NODE,
	FETCH_USER_COMMENTS,
	SET_USER_COMMENTS,
	SET_IS_LOADING_USER_COMMENTS,
	FETCH_DESIGNER_USER_FLOWS,
	FETCH_DESIGNER_FLOWS,
	SET_DESIGNER_FLOWS,
	FETCH_FLOW_VERSIONS,
	SET_FLOW_VERSIONS,
	SET_FLOW_VERSIONS_IS_LOADING,
	UPDATE_FLOW_VERSION,
	SWITCH_FLOW_EDIT_MODE,
	SET_FLOW_IS_LOADING,
	CHANGE_FLOW_MODE,
	VIEW_FLOW_VERSION,
	RELOAD_FLOWS,
	SET_FLOW_VERSIONS_DIALOG_OPEN,
	SET_CREATE_FLOW_VERSION_DIALOG_OPEN,
	SET_DELETE_FLOW_VERSION_DIALOG_OPEN,
	SET_FLOW_VERSION_TO_DELETE,
	SET_CHANGE_FLOW_VERSION_DIALOG_OPEN,
	SET_FLOW_VERSION_TO_USE,
	SET_IS_CHANGING_FLOW_MODE,
	FETCH_FLOW_CONFIGURATION,
	SET_FLOW_CONFIGURATION,
	FETCH_SHARED_FLOW_CONFIGURATIONS,
	SET_SHARED_FLOW_CONFIGURATIONS
} from 'redux/constants/flowDesigner';

export const fetchFlows = (tenant_id) => ({ type: FETCH_DESIGNER_FLOWS, payload: { tenant_id } });
export const fetchUserFlows = (tenant_id) => ({ type: FETCH_DESIGNER_USER_FLOWS, payload: { tenant_id } });
export const fetchFlowById = (tenant_id, flow_id, version) => ({ type: FETCH_FLOW_BY_ID, payload: { tenant_id, flow_id, version } });
export const setFlowById = (payload) => ({ type: SET_FLOW_BY_ID, payload });

export const duplicateFlow = (tenant_id, input) => ({ type: DUPLICATE_FLOW, payload: { tenant_id, input }, actionType: 'duplicate' });
export const updateCurrentFlow = (tenant_id, flow_id, input, userId) => ({ type: UPDATE_CURRENT_FLOW, payload: { tenant_id, flow_id, input, userId }, actionType: 'regular' });
export const createNewFlowProperties = (tenant_id, input) => ({ type: CREATE_NEW_FLOW_PROPERTIES, payload: { tenant_id, input }, actionType: 'props' });
export const updateCurrentFlowProperties = (tenant_id, flow_id, input, userId) => ({ type: UPDATE_CURRENT_FLOW_PROPERTIES, payload: { tenant_id, flow_id, input, userId }, actionType: 'props' });
export const autoCreateNewFlow = (tenant_id, input) => ({ type: AUTO_CREATE_NEW_FLOW, payload: { tenant_id, input }, actionType: 'auto' });
export const autoUpdateCurrentFlow = (tenant_id, flow_id, input, userId) => ({ type: AUTO_UPDATE_CURRENT_FLOW, payload: { tenant_id, flow_id, input, userId }, actionType: 'auto' });
export const clearCurrentSavedFlow = () => ({ type: CLEAR_CURRENT_SAVED_FLOW });
export const setSavedFlow = (payload) => ({ type: SET_SAVED_FLOW, payload });
export const setSavingFlowFlagReset = () => ({ type: SET_SAVING_FLOW_FLAG_RESET });
export const setAutoSavingFlowFlagReset = () => ({ type: SET_AUTO_SAVING_FLOW_FLAG_RESET });
export const setSavingFlowPropertiesFlagReset = () => ({ type: SET_SAVING_FLOW_PROPERTIES_FLAG_RESET });
export const setFlow = (tenant_id, flow) => ({ type: SET_FLOW, payload: { tenant_id, flow } });
export const clearFlow = () => ({ type: CLEAR_FLOW });
export const updateFlowSteps = (payload) => ({ type: UPDATE_FLOW_STEPS, payload });
export const openFlowListDialog = () => ({ type: OPEN_FLOW_LIST_DIALOG });
export const closeFlowListDialog = () => ({ type: CLOSE_FLOW_LIST_DIALOG });
export const setCanvasFlowInstance = (payload) => ({ type: SET_CANVAS_FLOW_INSTANCE, payload });
export const reloadFlow = () => ({ type: RELOAD_FLOW });
export const updateFlowThumbnail = (tenant_id, flow_id, file) => ({ type: UPDATE_FLOW_THUMBNAIL, payload: { tenant_id, flow_id, file } });

export const autoSaveOnCancelReset = () => ({ type: AUTO_SAVE_ON_CANCEL_RESET });
export const setFlows = (payload) => ({ type: SET_DESIGNER_FLOWS, payload });
export const startDragComponent = () => ({ type: START_DRAG_COMPONENT });
export const stopDragComponent = () => ({ type: STOP_DRAG_COMPONENT });
export const setNewTabFlag = (payload) => ({ type: SET_NEW_TAB_FLAG, payload });
export const openRecentActivitiesDialog = () => ({ type: OPEN_RECENT_ACTIVITIES_DIALOG });
export const closeRecentActivitiesDialog = () => ({ type: CLOSE_RECENT_ACTIVITIES_DIALOG });
export const shareFlow = (tenant_id, input) => ({ type: SHARE_DESIGNER_FLOW, payload: { tenant_id, input } });
export const unshareFlow = (tenant_id, user_id) => ({ type: UNSHARE_FLOW, payload: { tenant_id, user_id } });
export const setShareFlowFlagReset = () => ({ type: SET_SHARE_FLOW_FLAG_RESET });
export const updateShareFlow = (tenant_id, user_id, access_type) => ({ type: UPDATE_SHARE_FLOW, payload: { tenant_id, user_id, access_type } });
export const addFlowVariable = (payload) => ({ type: ADD_FLOW_VARIABLE, payload });
export const deleteFlowVariable = (payload) => ({ type: DELETE_FLOW_VARIABLE, payload });
export const updateFlowVariable = (id, data) => ({ type: UPDATE_FLOW_VARIABLE, payload: { id, data } });
export const setFlowVariables = (payload) => ({ type: SET_FLOW_VARIABLES, payload });
export const openDuplicateFlowDialog = () => ({ type: OPEN_DUPLICATE_FLOW_DIALOG });
export const closeDuplicateFlowDialog = () => ({ type: CLOSE_DUPLICATE_FLOW_DIALOG });
export const setNumberOfNodesLimitReached = (payload) => ({ type: SET_NUMBER_OF_NODES_LIMIT_REACHED, payload });

export const setCopiedNode = (payload) => ({ type: SET_COPIED_NODE, payload });

export const setCutNode = (payload) => ({ type: SET_CUT_NODE, payload });

export const setIsNotesDialogOpen = (payload) => ({ type: SET_IS_NOTES_DIALOG_OPEN, payload });

export const setNodeToAddNotes = (payload) => ({ type: SET_NODE_TO_ADD_NOTES, payload });

export const setDraggedNode = (payload) => ({ type: SET_DRAGGED_NODE, payload });

export const fetchUserComments = (tenant_id, flow_id, node_id) => ({ type: FETCH_USER_COMMENTS, payload: { tenant_id, flow_id, node_id } });

export const setUserComments = (payload) => ({ type: SET_USER_COMMENTS, payload });

export const setIsLoadingUserComments = (payload) => ({ type: SET_IS_LOADING_USER_COMMENTS, payload });

export const fetchFlowVersions = (tenant_id, flow_id) => ({ type: FETCH_FLOW_VERSIONS, payload: { tenant_id, flow_id } });

export const setFlowVersions = (payload) => ({ type: SET_FLOW_VERSIONS, payload });

export const setFlowVersionsIsLoading = (payload) => ({ type: SET_FLOW_VERSIONS_IS_LOADING, payload });

export const updateFlowVersion = (payload) => ({ type: UPDATE_FLOW_VERSION, payload });

export const switchFlowEditMode = (tenant_id) => ({ type: SWITCH_FLOW_EDIT_MODE, payload: { tenant_id } });

export const setFlowIsLoading = (payload) => ({ type: SET_FLOW_IS_LOADING, payload });

export const changeFlowMode = (payload) => ({ type: CHANGE_FLOW_MODE, payload });

export const viewFlowVersion = (tenant_id, flow_version) => ({ type: VIEW_FLOW_VERSION, payload: { tenant_id, flow_version } });

export const reloadFlows = () => ({ type: RELOAD_FLOWS });

export const setFlowVersionsDialogOpen = (payload) => ({ type: SET_FLOW_VERSIONS_DIALOG_OPEN, payload });

export const setCreateFlowVersionDialogOpen = (payload) => ({ type: SET_CREATE_FLOW_VERSION_DIALOG_OPEN, payload });

export const setDeleteFlowVersionDialogOpen = (payload) => ({ type: SET_DELETE_FLOW_VERSION_DIALOG_OPEN, payload });

export const setFlowVersionToDelete = (payload) => ({ type: SET_FLOW_VERSION_TO_DELETE, payload });

export const setChangeFlowVersionDialogOpen = (payload) => ({ type: SET_CHANGE_FLOW_VERSION_DIALOG_OPEN, payload });

export const setFlowVersionToUse = (payload) => ({ type: SET_FLOW_VERSION_TO_USE, payload });

export const setIsChangingFlowMode = (payload) => ({ type: SET_IS_CHANGING_FLOW_MODE, payload });

export const fetchFlowConfiguration = (payload) => ({ type: FETCH_FLOW_CONFIGURATION, payload });

export const setFlowConfiguration = (payload) => ({ type: SET_FLOW_CONFIGURATION, payload });

export const fetchSharedFlowConfigurations = () => ({ type: FETCH_SHARED_FLOW_CONFIGURATIONS });

export const setSharedFlowConfigurations = (payload) => ({ type: SET_SHARED_FLOW_CONFIGURATIONS, payload });
